import React from 'react';

const RightArrowCircle = () => {
  return (
    <svg width='64' height='64' viewBox='0 0 64 64' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g filter='url(#filter0_d_6968_177710)'>
        <circle cx='32' cy='24' r='16' fill='white' />
      </g>
      <mask
        id='mask0_6968_177710'
        mask-type='mask-type:alpha'
        maskUnits='userSpaceOnUse'
        x='24'
        y='16'
        width='16'
        height='16'
      >
        <rect x='24' y='16' width='16' height='16' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_6968_177710)'>
        <path
          d='M33.65 23.9998L28.75 19.0998C28.5833 18.9332 28.5028 18.7359 28.5083 18.5082C28.5139 18.2804 28.6 18.0832 28.7667 17.9165C28.9333 17.7498 29.1305 17.6665 29.3583 17.6665C29.5861 17.6665 29.7833 17.7498 29.95 17.9165L35.0667 23.0498C35.2 23.1832 35.3 23.3332 35.3667 23.4998C35.4333 23.6665 35.4667 23.8332 35.4667 23.9998C35.4667 24.1665 35.4333 24.3332 35.3667 24.4998C35.3 24.6665 35.2 24.8165 35.0667 24.9498L29.9333 30.0832C29.7667 30.2498 29.5722 30.3304 29.35 30.3248C29.1278 30.3193 28.9333 30.2332 28.7667 30.0665C28.6 29.8998 28.5167 29.7026 28.5167 29.4748C28.5167 29.2471 28.6 29.0498 28.7667 28.8832L33.65 23.9998Z'
          fill='#71767A'
        />
      </g>
      <defs>
        <filter
          id='filter0_d_6968_177710'
          x='0'
          y='0'
          width='64'
          height='64'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='8' />
          <feGaussianBlur stdDeviation='8' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_6968_177710' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_6968_177710' result='shape' />
        </filter>
      </defs>
    </svg>
  );
};

export default RightArrowCircle;
